<template>
  <div class="half-container">
    <table
      ref="subTable"
      class="desktop-table table table-bordered"
      :class="{ striped: forReport }"
    >
      <tr v-if="forReport">
        <td>Table Type</td>
        <td>{{ tableType }} Table</td>
      </tr>
      <tr>
        <td class="col-xs-5">Year(s)</td>
        <td class="col-xs-7">
          {{ store.state.selModel.years.display }}
        </td>
      </tr>
      <tr>
        <td>Location(s)</td>
        <td>
          {{
            commonModelHelper.getDisplayLocationsWithSelectionType(locations)
          }}
        </td>
      </tr>
      <tr v-for="(cell, i) in cells" v-bind:key="'cell' + i">
        <td>{{ cell.name }}</td>
        <td v-html="cell.display"></td>
      </tr>
      <tr v-if="!forReport">
        <td>Number Of Source Records</td>
        <td>{{ executionStats.records }}</td>
      </tr>
      <execution-time :viewport1="false"></execution-time>
    </table>
    <table
      class="mobile-table table table-bordered"
      :class="{ striped: forReport }"
    >
      <tr>
        <td>
          <div>Year(s)</div>
          <div>
            {{ store.state.selModel.years.display }}
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div>Location(s)</div>
          <div>
            {{
              commonModelHelper.getDisplayLocationsWithSelectionType(locations)
            }}
          </div>
        </td>
      </tr>
      <tr v-for="(cell, i) in cells" v-bind:key="'cell' + i">
        <td>
          <div>{{ cell.name }}</div>
          <div v-html="cell.display"></div>
        </td>
      </tr>
      <tr v-if="!forReport">
        <td>
          <div>Number Of Source Records</div>
          <div>{{ executionStats.records }}</div>
        </td>
      </tr>
      <execution-time :viewport1="true"></execution-time>
    </table>
    <!-- <div class="row hidden-print back-button" v-if="forReport">
      <input
        type="button"
        value="Back"
        class="btn btn-secondary btn-block"
        v-on:click="backClicked()"
        title="BackF"
      />
    </div> -->
  </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import common from "@/scripts/common";
import current from "@/scripts/current";
import commonModelHelper from "@/scripts/commonModelHelper";
import { mapGetters, mapState } from "vuex";
import executionTime from "@/components/executionTime";
import store from "@/store";

export default {
  props: {
    forReport: {
      default: false,
    },
    tableType: {},
    cells: {},
  },
  computed: {
    ...mapGetters({
      executionStats: "selModel/getExecutionStats",
    }),
    ...mapState({
      locations: (state) => state.selModel.locations,
    }),
  },
  components: {
    executionTime,
  },
  created: function () {},
  data: function () {
    return {
      selectionModel: current.selectionModel,
      current: current,
      commonModelHelper,
      store,
    };
  },
  mounted: function () {
    const vm = this;
    store.dispatch("loadedControls/mounted", {
      name: "myAnalysis",
      vm,
      height: vm.$refs.subTable.clientHeight,
    });
  },
  methods: {
    // getHeight: () => {
    //   const vm = this;
    //   return vm.$refs.subTable ? vm.$refs.subTable.clientHeight : 0;
    // },
    // () =>
    //   this.$refs.subTable ? this.$refs.subTable.clientHeight : 0,
    getDisplay: function (variable) {
      return variable.toString();
    },
    formatControlVariables() {
      var vm = this;
      //var current2 = current;
      var control1Display = current.selectionModel.v.control1.toString();
      var control2Display = current.selectionModel.v.control2.toString();
      var display = control1Display;
      if (control2Display.length > 0)
        display = display + ", " + control2Display;
      return display;
    },
  },
};
</script>

<style scoped>
.selectionModel-table div div {
  border: 1px solid black;
}

table.striped tr:nth-child(odd) {
  background-color: #e8e8e8; /*lightest*/
}

table.striped tr:nth-child(even) {
  background-color: #f5f5f5;
  /*background-color: #f5f5f5; */ /*lightest*/
  /*background-color: #e8e8e8; */ /*medium*/
  /*background-color: #e0e0e0; */ /*darkest*/
}

table.striped-light tr:nth-child(odd) {
  background-color: #f5f5f5;
}

table.striped-light tr:nth-child(even) {
  background-color: none;
  /*background-color: #f5f5f5; */ /*lightest*/
  /*background-color: #e8e8e8; */ /*medium*/
  /*background-color: #e0e0e0; */ /*darkest*/
}
/*.bottom-align-text {
    position: absolute;
    bottom: 0;
    right: 0;
  }*/

h4 {
  margin-bottom: 0px;
  margin-top: 0px;
  width: auto;
}

.hyperlink-button {
  position: relative;
  width: auto;
}

@media (min-width: 300px) {
  .select-button {
    padding-left: 30px;
  }
}

.col-xs-3 {
  width: 25%;
}

@media (min-width: 768px) {
  .col-sm-6 {
    width: 50%;
  }
}

td > div:first-child {
  font-weight: 500;
}

td > div:nth-child(2) {
  line-height: 25px;
}
.back-button {
  margin-top: 20px;
  width: 100%;
}

.back-button input {
  width: 50%;
}
.half-container {
  height: 100%;
}
</style>